import React, { useCallback, useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import {
  Form,
  Col,
  Input,
  Row,
  Typography,
  Select,
  Spin,
  Switch,
  InputNumber,
} from 'antd';
import DF from 'DisplayFramework';
import { getProposalById, PropThirdPartyResponse } from 'services/proposal';
import { toCurrency } from 'utils/utils';
import FormItem from 'antd/lib/form/FormItem';
import Value from 'components/Value';
import { indexBy, setValueByNamePath, shouldUpdateCompare } from 'utils/utils2';
import FormInput from 'components/FormInput';
import InputCurrency from 'components/InputCurrency';
import _ from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
import UtinaCard from 'components/UtinaCard';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import Text from 'antd/lib/typography/Text';
import { useQuery } from 'react-query';
import { isNil } from '@antv/util';

const { Text: AntText } = Typography;

const TabMasterFacilityUse = (props: any) => {
  const { form, object, objectid } = props;
  const [state, setState] = useState<any>({
    ASSETLIST: [],
    flagAsset: false,
    investamountinit: 0,
    investamount: 0,
    prcode: '',
  });
  const [load, setload] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fieldName = 'selectedAssets';

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const {
    data: proposal,
    refetch,
    isFetching: isFetch,
  } = useQuery(
    ['getProposalById', props.objectid],
    () =>
      getProposalById({ ctrid: Number(props.objectid) }).then(
        (res) => res.data
      ),
    { enabled: !isNil(props.objectid) }
  );

  // const loadCTDetail = useCallback(
  //   (ctrid) => {
  //     setload(true);
  //     props.setSuccessful(true);
  //     getProposalById({ ctrid })
  //       .then((response) => {
  //         const proposal = response.data;
  //         props.form.setFieldsValue({
  //           propreference: proposal.propreference,
  //           clientname: proposal.clientname,
  //           mfagreedamount: proposal.mfagreedamount,
  //           mfvaliditydate: proposal.mfvaliditydate,
  //           mfbookedamount: proposal.mfbookedamount,
  //           mfusedamount: proposal.mfusedamount,
  //           mfavailableamount: proposal.mfavailableamount,
  //           currcode: proposal.currcode,
  //           amountToUse: 0,
  //           splitAssets: false,
  //           flagAsset: proposal.flagasset,
  //           thirdParties: proposal.thirdParties,
  //           mfid: proposal.ctrid,
  //           mf: [],
  //         });
  //         const elemFin = proposal.conElements.find((e) => e.ctetype === 'FIN');

  //         let listAsset = proposal.assets.map((asset: any) => ({
  //           ...asset,
  //           mfAssetNetAmount:
  //             asset.assetqtyavailable * asset.assetunitnetamount,
  //         }));
  //         updateState({
  //           //ASSETLIST: proposal.assets.filter((a) => a.assetqtyavailable! > 0),
  //           ASSETLIST: listAsset,
  //           investamountinit: elemFin!.cteinvestamount,
  //           investamount: 0,
  //           flagAsset: proposal.flagasset,
  //           prcode: proposal.prcode,
  //         });
  //         setload(false);
  //         props.setSuccessful(false);
  //       })
  //       .catch(() => {
  //         props.setSuccessful(false);
  //         setload(false);
  //       });
  //   },
  //   [props.form, updateState]
  // );

  useEffect(() => {
    if (proposal) {
      form.setFieldsValue({
        event: 'tabMasterFacilityUse',
        propreference: proposal.propreference,
        clientname: proposal.clientname,
        mfagreedamount: proposal.mfagreedamount,
        mfvaliditydate: proposal.mfvaliditydate,
        mfbookedamount: proposal.mfbookedamount,
        mfusedamount: proposal.mfusedamount,
        mfavailableamount: proposal.mfavailableamount,
        currcode: proposal.currcode,
        amountToUse: 0,
        splitAssets: false,
        flagAsset: proposal.flagasset,
        thirdParties: proposal.thirdParties,
        mfid: proposal.ctrid,
        mf: [],
      });
      const elemFin = proposal.conElements.find((e) => e.ctetype === 'FIN');

      let listAsset = proposal.assets.map((asset: any) => ({
        ...asset,
        // assetNetAmount: asset.assetqtyavailable * asset.assetunitnetamount,
        mfAssetNetAmount: asset.assetqtyavailable * asset.assetunitnetamount,
        mfassetqty: asset.assetqtyavailable,
        selected: false,
      }));

      updateState({
        //ASSETLIST: proposal.assets.filter((a) => a.assetqtyavailable! > 0),
        ASSETLIST: listAsset,
        investamountinit: elemFin!.cteinvestamount,
        investamount: 0,
        flagAsset: proposal.flagasset,
        prcode: proposal.prcode,
      });

      setload(false);

      if (proposal.flagasset) {
        props.setSuccessful(true);
      } else {
        props.setSuccessful(false);
      }

      form.setFieldsValue({
        [fieldName]: listAsset,
      });
    } else {
      props.setSuccessful(true);

      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [proposal]);

  const rowSelection = {
    onSelect: (selectedRow: any, isSelect: any) => {
      // if(isSelect===false)
      // props.form.setFieldsValue({
      //   mf: props.form.getFieldValue("mf").filter((asset:any)=>asset.assetid!==selectedRow.assetid),
      // });
    },
    onChange: (selectedRowKeys: any, selectedRows: any[]) => {
      // let total = 0;
      // let listAsset = [];
      // let mfnetamnt = 0;
      // let mfassetqty = 0;

      // const mf = props.form.getFieldValue('mf') ?? [];
      // let mfnew = mf;
      // for (const i in selectedRows) {
      //   const index =
      //     mf !== undefined
      //       ? mf.findIndex((mf: any) => mf?.assetid === selectedRows[i].assetid)
      //       : null;
      //   mfnetamnt = isNaN(
      //     Number(props.form.getFieldValue(['mf', index, 'mfAssetNetAmount']))
      //   )
      //     ? selectedRows[i].assetqtyavailable *
      //       selectedRows[i].assetunitnetamount
      //     : Number(props.form.getFieldValue(['mf', index, 'mfAssetNetAmount']));

      //   total += mfnetamnt;
      //   mfassetqty = isNaN(
      //     Number(props.form.getFieldValue(['mf', index, 'mfassetqty']))
      //   )
      //     ? selectedRows[i].assetqtyavailable
      //     : Number(props.form.getFieldValue(['mf', index, 'mfassetqty']));

      //   listAsset.push({
      //     assetid: selectedRows[i].assetid,
      //     assetNetAmount: mfnetamnt,
      //     assetqty: mfassetqty,
      //   });
      //   if (
      //     mfnew.find((mf: any) => mf.assetid === selectedRows[i].assetid) ===
      //     undefined
      //   ) {
      //     mfnew.push({
      //       assetid: selectedRows[i].assetid,
      //       assetNetAmount: mfnetamnt,
      //       assetqty: mfassetqty,
      //       mfAssetNetAmount: mfassetqty * selectedRows[i].assetunitnetamount,
      //       assetunitnetamount: selectedRows[i].assetunitnetamount,
      //     });
      //     props.form.setFieldsValue({
      //       mf: mfnew,
      //     });
      //   }
      // }

      // props.form.setFieldsValue({
      //   amountToUse: total,
      //   selectedAssets: listAsset,
      // });
      // updateState({
      //   investamount: total,
      //   selectedRowKeys,
      // });

      const selectedAssets = form.getFieldValue(fieldName) ?? [];
      let amountToUse = 0;

      let newList = selectedAssets.map((e: any) => {
        let isSelected =
          selectedRowKeys.findIndex((x: any) => x === e.assetid) !== -1;

        if (isSelected) {
          amountToUse += e.mfAssetNetAmount;
        }

        return {
          ...e,
          selected: isSelected,
          mfassetqty: isSelected ? e.mfassetqty : e.assetqtyavailable,
        };
      });

      form.setFieldValue(fieldName, newList);
      form.setFieldValue('amountToUse', amountToUse);

      setSelectedRowKeys(selectedRowKeys);
      if (selectedRowKeys.length > 0) {
        props.setSuccessful(false);
      } else {
        props.setSuccessful(true);
      }
    },
    getCheckboxProps: (record: any) => {
      const disabled = record.assetqtyavailable === 0;
      return {
        disabled: disabled,
      };
    },
    selectedRowKeys: selectedRowKeys,
  };
  const handleLineChange = (assetid: number, assetQty: number) => {
    if (assetQty > 0) {
      if (!_.includes(state.selectedRowKeys, assetid))
        updateState({
          selectedRowKeys: [...state.selectedRowKeys, assetid],
        });
    } else
      updateState({
        selectedRowKeys: state.selectedRowKeys.filter(
          (e: any) => e !== assetid
        ),
      });
  };

  const getName = useCallback(
    (name: string) => (record: any) => {
      const actions = form.getFieldValue(fieldName);
      const index = indexBy(actions, 'assetid')[record.assetid];
      return [fieldName, index, name];
    },
    [form]
  );

  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'Asset.assetreference',
      dataIndex: 'assetreference',
      width: 100,
      fixed: 'left',
    },
    {
      comcode: 'Asset.assetdescription',
      dataIndex: 'assetlabel',
      width: 180,
    },
    {
      comcode: 'Asset.assetstatuslabel',
      dataIndex: 'statuslabel',
      width: 100,
      render: (statuslabel, record) =>
        record.assetstatus !== props.status ? (
          <Text type="warning">{statuslabel}</Text>
        ) : (
          <Text style={{ color: 'green' }}>{statuslabel}</Text>
        ),
    },
    {
      comcode: 'Asset.assetorderreference',
      dataIndex: 'assetorderreference',
      width: 100,
    },
    {
      comcode: 'Asset.assetdeliveryreference',
      dataIndex: 'assetdeliveryreference',
      width: 100,
    },
    {
      comcode: 'Asset.assetdeliverydate',
      dataIndex: 'assetdeliverydate',
      width: 100,
    },
    {
      comcode: 'Asset.suppliername',
      dataIndex: 'suppliername',
      width: 180,
    },
    {
      align: 'right',
      comcode: 'Asset.assetnetamount',
      dataIndex: 'assetnetamount',
      fixed: 'right',
      render: (value) =>
        toCurrency(
          value,
          props?.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      width: 120,
    },
    {
      align: 'right',
      comcode: 'Asset.assetfinamount',
      dataIndex: 'assetfinamount',
      fixed: 'right',
      render: (value) =>
        toCurrency(
          value,
          props?.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      width: 120,
    },
    {
      comcode: 'Asset.assetrentalpart',
      dataIndex: 'rentalpart',
      render: (value) =>
        toCurrency(
          value,
          props?.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      fixed: 'right',
      width: 100,
      align: 'right',
    },
    {
      comcode: 'Asset.assetrvamount',
      dataIndex: 'assetrvamount',
      render: (value) =>
        toCurrency(
          value,
          props?.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      fixed: 'right',
      width: 100,
      align: 'right',
    },

    {
      align: 'right',
      comcode: 'Asset.assetqty',
      dataIndex: 'assetqty',
      fixed: 'right',
      width: 120,
    },

    {
      align: 'right',
      comcode: 'Asset.assetqtyavailable',
      dataIndex: 'assetqtyavailable',
      fixed: 'right',
      width: 120,
    },
    {
      comcode: 'Asset.assetunitnetamount',
      dataIndex: 'assetunitnetamount',
      render: (value) =>
        toCurrency(
          value,
          props?.currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      fixed: 'right',
      width: 100,
      align: 'right',
    },
    {
      comcode: 'mfassetqty',
      dataIndex: 'mfassetqty',
      render: (val, record, index) => (
        <FormInput name={getName('mfassetqty')(record)} noStyle>
          <InputNumber
            max={record.assetqtyavailable}
            min={0}
            onChange={(e) => {
              if (e <= record.assetqtyavailable) {
                const mfAssetNetAmount = e * record.assetunitnetamount;
                setValueByNamePath(
                  form,
                  getName('mfAssetNetAmount')(record),
                  mfAssetNetAmount
                );
              }
              let assetList = form.getFieldValue(fieldName) ?? [];
              let amountToUse = 0;
              assetList.forEach((e: any) => {
                if (e.selected) {
                  amountToUse += e.mfAssetNetAmount;
                }
              });

              form.setFieldValue('amountToUse', amountToUse);
            }}
            disabled={
              selectedRowKeys.findIndex((x) => x === record.assetid) === -1
            }
          />
        </FormInput>
      ),
      fixed: 'right',
      width: 150,
      align: 'right',
    },

    {
      comcode: 'mfAssetNetAmount',
      dataIndex: 'mfAssetNetAmount',
      render: (val, record, index) => (
        <InputCurrency
          currcode={props?.currcode ?? localStorage.getItem('currcode') ?? ''}
          comcode="mfAssetNetAmount"
          fieldname={getName('mfAssetNetAmount')(record)}
          defaultValue={val}
          noStyle
          disabled
        />
      ),
      fixed: 'right',
      width: 150,
      align: 'right',
    },
  ];

  return (
    <DF.Provider
      pagcode="tabMasterFacilityUse"
      entity={object}
      entityid={objectid}
    >
      <Spin spinning={load || isFetch}>
        <Row gutter={16}>
          <UtinaCard comcode="MasterFacility" level={5} lg={7}>
            <Row gutter={16}>
              <FormInput col md={24} name="mfagreedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="mfbookedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="mfusedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="mfavailableamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>
            </Row>
          </UtinaCard>
          <UtinaCard comcode="MasterFacility_beneficiary" level={5} lg={7}>
            <Row gutter={10}>
              <FormItem
                shouldUpdate={shouldUpdateCompare('thirdParties')}
                rules={[{ required: true }]}
                noStyle
              >
                {({ getFieldValue }) => {
                  return (
                    <FormInput col md={24} name="tpidbeneficiary">
                      <Select
                        onSelect={(e) => {
                          let tps = getFieldValue('thirdParties')?.find(
                            (tp: PropThirdPartyResponse) =>
                              tp.tpid === e && tp.tprolecode === 'MFBENEF'
                          );
                          props.form.setFieldsValue({
                            beneficiaryname: tps.tpname,
                            beneficiaryreference: tps.tpreference,
                            tpbnef_mfavailableamount: tps.mfavailableamount,
                            tpbnef_mfbookedamount: tps.mfbookedamount,
                            tpbnef_mfrequestedamount: tps.mfrequestedamount,
                            tpbnef_mfusedamount: tps.mfusedamount,
                            tpbnef_mfagreedamount: tps.mfagreedamount,
                          });
                        }}
                      >
                        {getFieldValue('thirdParties')?.map(
                          (tp: PropThirdPartyResponse) =>
                            tp.tprolecode === 'MFBENEF' &&
                            tp.status === 'ACTIVE' && (
                              <Select.Option value={tp.tpid} key={tp.tpid}>
                                {tp.tpname}
                              </Select.Option>
                            )
                        )}
                      </Select>
                    </FormInput>
                  );
                }}
              </FormItem>

              <FormInput col md={24} name="tpbnef_mfagreedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="tpbnef_mfbookedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="tpbnef_mfusedamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>

              <FormInput col md={24} name="tpbnef_mfavailableamount">
                <Value formatter={(value) => toCurrency(value)} />
              </FormInput>
              {state.flagAsset && (
                <FormInput
                  name="splitAssets"
                  hidden={!state.flagAsset}
                  valuePropName="checked"
                  md={24}
                >
                  <Switch />
                </FormInput>
              )}

              <InputCurrency
                col
                md={24}
                currcode={props.form.getFieldValue('currcode')}
                comcode="amountToUse"
                fieldname="amountToUse"
                disabled={state.flagAsset}
              />

              <Col span={18} />
              {state.flagAsset && (
                <Col span={24} style={{ textAlign: 'right' }}>
                  <AntText type="warning">
                    <GetLabel label="TotalAssetsAmount" /> :
                    {toCurrency(
                      state.investamountinit,
                      props.form.getFieldValue('currcode')
                    )}
                  </AntText>
                  <br />
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => (
                      <AntText type="danger">
                        <GetLabel label="TotalSelectedAssets" /> :
                        {toCurrency(
                          getFieldValue('amountToUse'),
                          props.form.getFieldValue('currcode')
                        )}
                      </AntText>
                    )}
                  </FormItem>

                  <br />
                </Col>
              )}
            </Row>
            <FormItem
              name="selectedAssets"
              rules={[{ required: state.flagAsset }]}
              noStyle
            ></FormItem>
            <FormItem name="flagAsset" noStyle>
              <Input hidden />
            </FormItem>
            <FormItem
              name="mfid"
              rules={[{ required: true }]}
              noStyle
            ></FormItem>

            <Form.Item
              style={{ margin: 0 }}
              name="amountToUse"
              rules={[
                {
                  required: true,
                  message: 'amountToUse is required',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value > getFieldValue('mfavailableamount')) {
                      return Promise.reject(
                        new Error('amountToUse’ must be <= Mfavailableamount')
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input value={state.selectedRowKeys} hidden />
            </Form.Item>
          </UtinaCard>
          <Col span={24}>
            {state.flagAsset && (
              // <AssetsTable
              //   currcode={props.form.getFieldValue('currcode')}
              //   mfcolumn
              //   handleLineChange={handleLineChange}
              //   form={props.form}
              //   size="small"
              //   scroll={{ x: 1000, y: 400 }}
              //   pagination={{ pageSize: 10 }}
              //   rowSelection={{
              //     type: 'checkbox',
              //     ...rowSelection,
              //   }}
              //   dataSource={state.ASSETLIST}
              //   rowKey={(record) => record.assetid}
              // />

              <Form.Item
                noStyle
                shouldUpdate
                // rules={[{ required: true }]}
                // name={fieldName}
              >
                {({ getFieldValue }) => {
                  const assets: any[] = getFieldValue(fieldName);
                  return (
                    <DataGrid
                      rowKey="assetid"
                      dataSource={assets}
                      columns={columns}
                      // isLoading={isFetching}
                      titleComcode="assetlist"
                      hideFilters
                      rowSelection={rowSelection}
                      // extraActions={
                      //   <AntdButton
                      //     type="primary"
                      //     // icon={<PlusOutlined />}
                      //     onClick={addRow}
                      //     disabled={isNewItemInTable}
                      //   >
                      //     Add
                      //   </AntdButton>
                      // }
                    />
                  );
                }}
              </Form.Item>
            )}
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabMasterFacilityUse;
